<div class="main__container">

	<breadcrumb title="Aplicaciones"></breadcrumb>

	<div class="section__container">
		<div class="box__container titulo__container">
			<!-- Título -->
			<div class="titulo">
				<div>
					<div>Aplicaciones</div>
					<div class="cantidad__apps">
						<ng-container *ngIf="filteredAccesos$ | async as accesos">
							{{ accesos.length }}
							<ng-container *ngIf="accesos.length == 1">aplicación</ng-container>
							<ng-container *ngIf="accesos.length != 1">aplicaciones</ng-container>
							con acceso
						</ng-container>

					</div>
				</div>
				<div class="filter__container">
					<input #appFilter type="text" class="filter" placeholder="Buscador de aplicaciones">
					<div class="search__button"></div>
				</div>
			</div>
		</div>

		<!-- Listado de aplicaciones-->
		<div class="contenido__box">
			<div class="contenido__container">
				<div class="acceso__container">
					<ng-container *ngIf="filteredAccesos$ | async as accesos">
						<ng-container *ngIf="accesos.length > 0">

							<ng-container *ngFor="let acceso of accesos, let isLast = last">
								<ng-container [ngTemplateOutlet]="card" [ngTemplateOutletContext]="{ acceso: acceso }"></ng-container>
								<div *ngIf="!isLast" class="sep"></div>
							</ng-container>

						</ng-container>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>



<ng-template #card let-acceso="acceso">
	<div class="icon"><app-icon [nombre]="acceso.nombre" [desc]="acceso.desc" [color]="colors[acceso.nombre]" [sizeInRem]="ICON_SIZE" [textSizeInRem]="ICON_TEXT_SIZE"></app-icon></div>

	<div class="desc">
		{{acceso.desc}} <br class="d-md-none"><span *ngIf="acceso.perfiles.length == 1" class="perfil__desc">( {{ acceso.perfiles[0].desc }} )</span>
	</div>

	<div class="perfiles">
		<ng-container *ngIf="acceso.perfiles.length == 1">
			<button class="btn ingresar" [managedLink]="STORED_LINK" [queryParams]="{ ida: acceso.nombre, idp: acceso.perfiles[0].nombre }" [gtagEvent]="'acceder-' + acceso.nombre" gtagCategory="aplicacion" >Ingresar</button>
		</ng-container>
		<ng-container *ngIf="acceso.perfiles.length > 1">
			<div ngbDropdown placement="bottom-right">
				<button class="btn ingresar text-wrap" ngbDropdownToggle>Ingresar como</button>
				<div ngbDropdownMenu>
					<ng-container *ngFor="let perfil of acceso.perfiles">
						<button class="ingresar_perfil" ngbDropdownItem [managedLink]="STORED_LINK" [queryParams]="{ ida: acceso.nombre, idp: perfil.nombre }" [gtagEvent]="'acceder-' + acceso.nombre" gtagCategory="aplicacion">{{perfil.desc}}</button>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</div>

	<ng-container *ngIf="acceso.ready == null || acceso.ready">
		<div class="marked" [ngClass]="{ 'marked-on': acceso.marked, 'marked-off': !acceso.marked }" (click)="onToggleMark( acceso )" [gtagLabel]="acceso.nombre" [gtagEvent]="acceso.marked? 'desmarcar-favorito': 'marcar-favorito'" gtagCategory="aplicacion"></div>
	</ng-container>
	<ng-container *ngIf="acceso.ready != null && !acceso.ready">
		<div class="marked" [ngClass]="{ 'marked-on': acceso.marked, 'marked-off': !acceso.marked, working: true }" (click)="onToggleMark( acceso )"></div>
	</ng-container>
</ng-template>